export enum WorkOrderPoStatusEnum {
  InProgress = "InProgress",
  Completed = "Completed",
  Canceled = "Canceled",
}
